import * as React from "react";
import { createFileRoute, useNavigate, Link } from "@tanstack/react-router";
// helpers
import { useAccessPermission } from "@/helpers/acessPermission";

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Button } from "@/components/ui/button";

import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent,
} from "@/components/ui/card";
import { ArrowLeft, PencilLine, Download } from "lucide-react";

import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";
const DataTest = [
  {
    ID: "13er4",
    Content: "ອາກອນກຳໄລ",
    TheVAT: "423,000",
  },
  {
    ID: "13er4",
    Content: "ອາກອນກຳໄລມອບເກີນ ຫຼື ມອບເພີ່ມ",
    TheVAT: "423,000",
  },
  {
    ID: "13er4",
    Content: "ອາກອນເງິນເດືອນ",
    TheVAT: "423,000",
  },
  {
    ID: "13er4",
    Content: "ອາກອນມູນຄ່າເພີ່ມ (ອຜມ)",
    TheVAT: "423,000",
  },
  {
    ID: "13er4",
    Content: "ອາກອນຊົມໃຊ້",
    TheVAT: "423,000",
  },
  {
    ID: "13er4",
    Content: "ອາກອນເງິນປັນຜົນ",
    TheVAT: "423,000",
  },
  {
    ID: "13er4",
    Content: "ອາກອນອື່ນໆ",
    TheVAT: "423,000",
  },
  {
    ID: "13er4",
    Content: "ມູນຄາອາກອນຫຼຸດ/ເພິ່ມ",
    TheVAT: "423,000",
  },
];
export const Route = createFileRoute(
  "/_layout-private/report/obligation/assign-tax-obligation/$id"
)({
  component: RouteComponent,
});

function RouteComponent() {
  const navigate = useNavigate();
  const { delegationReport } = useAccessPermission();
  return (
    <section>
      <Breadcrumb>
        <BreadcrumbList>
          <BreadcrumbItem>
            <BreadcrumbLink>
              <Link
                replace
                to="/report/obligation"
                search={{
                  active: "assignTaxObligations",
                  startYear: 0,
                  endYear: 0,
                }}
              >
                ລາຍງານການເງິນຂອງບໍລິສັດ
              </Link>
            </BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbSeparator />

          <BreadcrumbItem>
            <BreadcrumbPage>ລາຍງານພັນທະອາກອນ</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>

      <Card className="mt-8">
        <CardHeader>
          <button
            type="button"
            onClick={() =>
              navigate({
                to: "/report/obligation/assign-tax-obligation",
              })
            }
            className="flex items-center gap-1 mb-4"
            aria-label="Go back to tax obligations report"
          >
            <ArrowLeft className="w-5 h-5" />
            ກັບຄືນ
          </button>
          <CardTitle>ລາຍລະອຽດເອກະສານມອບພັນທະໃຫ້ລັດງວດປີ 2023</CardTitle>
          <CardDescription>ລາຍລະອຽດ</CardDescription>
          <div className="flex justify-end w-full my-5 gap-x-2">
            {delegationReport.isUpdate && (
              <Button
                onClick={() =>
                  navigate({
                    to: "/report/obligation/assign-tax-obligation/edit",
                  })
                }
                variant="secondary"
                className="flex items-center border border-blue-500 bg-none gap-x-1 w-[120px] rounded-md  p-2 text-blue-500"
              >
                <PencilLine /> ແກ້ໄຂ
              </Button>
            )}
          </div>
        </CardHeader>
        <CardContent>
          <CardTitle>ປະຈຳປີ 2023</CardTitle>

          <div>
            <Table className="w-full my-4 ">
              <TableHeader>
                <TableRow className="font-bold text-black bg-gray-100">
                  <TableHead className="border">ເນຶ້ອໃນລາຍງານ </TableHead>
                  <TableHead className="border">ມູນຄ່າອາກອນ</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {DataTest.map((invoice, index) => (
                  <TableRow key={invoice.ID} className="cursor-pointer">
                    <TableCell className="font-medium border">
                      {invoice.Content}
                    </TableCell>
                    <TableCell className="font-bold border">
                      {invoice.TheVAT} ກີບ
                    </TableCell>
                  </TableRow>
                ))}
                <TableRow className="bg-gray-100 cursor-pointer">
                  <TableCell className="font-medium border">
                    ລວມມອບອາກອນໃນປີ
                  </TableCell>

                  <TableCell className="font-bold border">
                    2,400,000,000,000 ກີບ
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </div>

          <Card className="flex flex-col justify-center w-3/12 h-24 mb-4 bg-gray-100">
            <CardDescription className="p-2 px-4 font-bold text-left text-green-700 text-md">
              ເອກະສານຕິດຄັດ
            </CardDescription>

            <CardContent className="flex items-center justify-around p-2">
              <CardDescription className="text-left underline">
                ທະນາຄານການຄ້າຕ່າງປະເທດລາວ.Excel
              </CardDescription>
              <CardDescription className="flex items-center justify-center w-10 h-10 border rounded-md">
                <Download size={24} color="green" />
              </CardDescription>
            </CardContent>
          </Card>
        </CardContent>
      </Card>
    </section>
  );
}
